import { useState } from "react";
import BasetEditor, { EditorProps } from ".";

export interface IProps extends EditorProps {
  name: string;
  dataTyp?: string;
  updateAble?: string;
}

export default function Editor({
  id,
  defaultValue,
  name,
  dataTyp = "C",
  updateAble = "false",
}: IProps) {
  const [editorHtml, setEditorHtml] = useState({
    id: "",
    content: "",
  });

  const onChange = (id: string, content: string) => {
    setEditorHtml({
      id,
      content,
    });
  };

  return (
    <div
      key={id}
      className="w-full flex-1"
      data-updateable={updateAble}
      onFocus={(e) => {
        const textarea = e.currentTarget.childNodes[0] as HTMLTextAreaElement;
        const { updateable } = e.currentTarget.dataset;
        if (updateable === "true") {
          textarea.setAttribute("data-type", "U");
        }
        textarea.value = editorHtml.content;
      }}
    >
      <textarea
        name={name}
        className="editor-textarea"
        // value={defaultValue || editorHtml.content}
        value={editorHtml.content || defaultValue}
        hidden
        data-type={"C"}
        readOnly
      />
      <BasetEditor
        id={id}
        key={id}
        defaultValue={defaultValue}
        readonly={dataTyp === "R"}
        onChange={onChange}
      />
    </div>
  );
}
